import { Category } from 'api/interface/Category.ts';

class GetStyleCategoriesResponse {
	public categories: Category[];

	constructor(categoriesData: Category[]) {
		this.categories = categoriesData;
	}

	formatCategoriesData() {
		if (Array.isArray(this.categories)) {
			return this.categories.map((category) => {
				const featureOptions = [];
				if (category.attributes.quality) {
					featureOptions.push({
						featureText: 'Quality',
						strength: category.attributes.quality,
					});
				}

				if (category.attributes.control_net) {
					featureOptions.push({
						featureText: 'ControlNet',
						strength: category.attributes.control_net,
					});
				}

				if (category.attributes.facelock) {
					featureOptions.push({
						featureText: 'Facelock',
						strength: category.attributes.facelock,
					});
				}

				return {
					id: category.id,
					displayName: category.display_name,
					name: category.name,
					featureOptions,
				};
			});
		}
		return [];
	}
}

export default GetStyleCategoriesResponse;
